<template>
  <div class="hello">
<!--    <h2>{{ msg }}</h2>-->
    <ul id="text-intro">
      <li>
        <h2 style="font-weight : bold;">项目简介</h2>
        <p>
          教师在申报各类项目时，需要提供教师在其职业生涯期间的成果的一些证明材料，其系业绩佐证。随着教师业绩佐证种类的增多，业绩佐证的整理和对应佐证文档的制作愈发困难。据我们的市场调查，市面上目前并没有专门为教师群体设计的业绩佐证管理系统。
        </p>
        <p>
          为解决这一困境，本项目利用 OCR 技术自动识别教师上传的业绩佐证图片上的文字，并使用 NLP 技术自动提取有关信息。再利用数据库进行保存。在教师需要时，通过保存的数据自动生成佐证文档。其使用阿里云 OSS 保存教师上传的图片，以提高在获取对应佐证图片的时候的稳定性以及安全性。本软件使用 B/S 架构建设，用户无需安装即可使用。
        </p>
      </li>
      <br>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '智能业绩佐证管理系统'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body{
  background: linear-gradient(to left bottom,hsl(9,100%,85%)0%,hsl(146,100%,85%)100%);
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.hello {
  margin : 0 12.5% 0 12.5%;
}

#text-intro {
  border : 1.5px red solid;
  background : white;
  border-radius : 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue